import * as React from 'react';

type DIContainer = {
  authService: Bluebeam.Services.IAuthService;
  deviceStorageService: Bluebeam.Services.IDeviceStorageService;
  featureFlagService: Bluebeam.Services.IFeatureFlagService;
};

const DIContainerContext = React.createContext<DIContainer | undefined>(
  undefined
);

const createDIContainerProvider =
  (diContainer: DIContainer): React.FC =>
  ({ children }) => {
    return (
      <DIContainerContext.Provider value={diContainer}>
        {children}
      </DIContainerContext.Provider>
    );
  };

export { createDIContainerProvider, DIContainerContext };

if (process.env.NODE_ENV !== 'production') {
  DIContainerContext.displayName = 'DIContainerContext';
}
